// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-options-icon-item .fi-options-item-wrapper .mat-icon {
  font-size: 18px;
  line-height: 40px;
  height: 100%;
}
.fi-options-icon-item .fi-options-item-wrapper.selected :before {
  color: var(--fi-color-white);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-options/fi-options-icon-item.component.scss"],"names":[],"mappings":"AAEQ;EACI,eAAA;EACA,iBAAA;EACA,YAAA;AADZ;AAIY;EACI,4BAAA;AAFhB","sourcesContent":[".fi-options-icon-item {\r\n    .fi-options-item-wrapper {\r\n        .mat-icon {\r\n            font-size: 18px;\r\n            line-height: 40px;\r\n            height: 100%;\r\n        }\r\n        &.selected {\r\n            :before {\r\n                color: var(--fi-color-white);\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
